import { useTheme } from '@xstyled/styled-components';
import { useMemo } from 'react';

export function useColor(correct?: boolean) {
  const theme = useTheme() as {
    colors?: { greenDark?: string; redDark?: string };
  };
  return useMemo(() => {
    switch (correct) {
      case true:
        return theme?.colors?.greenDark as string;
      case false:
        return theme?.colors?.redDark as string;
      default:
        return 'transparent';
    }
  }, [correct]);
}
